/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class BikeInfoApi {
    static getInstance() {
        if (!this.instance) this.instance = new BikeInfoApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取车辆信息
    async getBikeInfo (user_id, frame_number, assembly_code){
        let url = `/api/report/sys/vehicle/${user_id}?frame_number=${frame_number}&assembly_code=${assembly_code}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 导出车辆信息
    async exportInfo (user_id, frame_number, assembly_code){
        let url = `/api/report/sys/vehicle/download/${user_id}?frame_number=${frame_number}&assembly_code=${assembly_code}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 生成电机二维码
    async getQRCode(param){
        let url = `/api/sys/vehicle/triple/code`
        let result = await this.getData(url,param,'GET')
        return result
    }

}

export {
    BikeInfoApi
}